import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AterpeaSpinnerComponent } from './spinner/spinner.component';
import { TablaAutomaticaModule } from './tabla-automatica/tabla-automatica.module';
import { VerAdjuntoModule } from './ver-adjunto/ver-adjunto.module';

const components = [
  AterpeaSpinnerComponent
]

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    TablaAutomaticaModule,
    VerAdjuntoModule
  ],
  declarations: components,
  exports: components
})
export class SharedComponentsModule { }
